import { gql } from "@apollo/client";

const MISSION_ROLE_APPLICANT_VIEWS_COUNT = gql`
  query MissionRoleApplicantViewsCount($ids: [ID!]!) {
    missionRoleApplicantViewsCount(ids: $ids) {
      id
      totalViews
      totalViewsWithoutAdmin
      totalViewsBreakdown {
        admin
        client
        freelancer
        system
      }
    }
  }
`;

export { MISSION_ROLE_APPLICANT_VIEWS_COUNT };
